import { Button } from '../ui';

interface StepNavigationProps {
  onBack?: () => void;
  onContinue: () => void;
  canContinue?: boolean;
  continueLabel?: string;
  backLabel?: string;
  showBack?: boolean;
  loading?: boolean;
}

export default function StepNavigation({
  onBack,
  onContinue,
  canContinue = true,
  continueLabel = 'Continue',
  backLabel = 'Back',
  showBack = true,
  loading = false,
}: StepNavigationProps) {
  return (
    <div className="step-navigation step-navigation--stacked">
      {showBack && onBack && (
        <div className="step-navigation__back">
          <Button
            variant="ghost"
            size="lg"
            onClick={onBack}
            fullWidth
            icon={
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="19" y1="12" x2="5" y2="12" />
                <polyline points="12 19 5 12 12 5" />
              </svg>
            }
          >
            {backLabel}
          </Button>
        </div>
      )}
      <div className="step-navigation__continue">
        <Button
          variant="primary"
          size="lg"
          onClick={onContinue}
          disabled={!canContinue}
          loading={loading}
          fullWidth
          icon={
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          }
          iconPosition="right"
        >
          {continueLabel}
        </Button>
      </div>
    </div>
  );
}
